export default class Home {

    constructor(common) {
        this.common = common;
        this.view = document.querySelector('body#home');

        if (this.view) {
            this.init();
        }
    }

    init() {
        HomeSlide.init(this.view.querySelector('.mainimage'));

        // const worker = new Worker("/assets/js/page/works.js");
        // let parentElements = document.querySelectorAll(".img01"); // img01要素を全て取得
		// console.log(parentElements);
		// const elementsData = Array.from(parentElements).map(element => ({
		// 	id: element.id || null,
		// 	className: element.className || null,
		// 	src: element.src || null,
		// 	alt: element.alt || null,
		// }));

		// // データをWeb Workerに送信
		// worker.postMessage(elementsData);
		HomeAnime.init();

        // parentElements.forEach((parentElement,index) => {
        //     // this.createWorker(parentElement);
		// 	console.log(parentElement);
        // });

    }
}

class HomeSlide {

    static init(view) {
        this.view = view;
        this.slides = this.view.querySelector('.slide_list');
        this.duration = this.view.dataset.duration || 7000;
        this.srcs = [];
        this.count = 0;

        this.loadImages();
    }

    static loadImages() {
        const slideElements = this.slides.children;

        // 画像のURLを取得
        Array.from(slideElements).forEach(slide => {
            const backgroundImage = window.getComputedStyle(slide).backgroundImage;
            const match = backgroundImage.match(/url\("(.+)"\)/);
            if (match) {
                const src = match[1];
                this.srcs.push(src);
            }
        });

        // 画像をロードして、すべての画像が読み込まれたらスライドを開始
        this.srcs.forEach(src => {
            const img = new Image();
            img.onload = img.onerror = () => {
                if (++this.count === this.srcs.length) {
                    this.view.classList.add('active');
                    this.slide(true);
                }
            };
            img.src = src;
        });
    }

    static slide(first) {
        const slide = this.slides.querySelector('.slide');
        if (!slide) return;

        slide.classList.remove('active');
        this.slides.removeChild(slide);
        const newSlide = slide.cloneNode(true);
        this.slides.appendChild(newSlide);

        setTimeout(() => {
            newSlide.classList.add('active');
            setTimeout(() => this.slide(), this.duration - 100);
        }, 100);
    }
}

let HomeAnime = {
	init : function(){
		let parentElements = document.querySelectorAll( ".img01" );//img01要素を全て取得
		parentElements.forEach( parentElement =>{
			this.SectionAnime(parentElement);
		 });
	},
	SectionAnime : function(parentElement){
		const TimeDuration = 3000;
		// const TimeDuration = 5000;
		const TimeDuration02 = 2000;
		const TimeDuration03 = 1000;
		setInterval(() =>{
			let firstElementChild = parentElement.firstElementChild; //1枚目の画像
			let lastElementChild = parentElement.lastElementChild;//1枚目の画像

			let firstElementChild02 = parentElement.nextElementSibling.firstElementChild;
			let lastElementChild02 = parentElement.nextElementSibling.lastElementChild;

			if(firstElementChild.classList.contains("init")){
				lastElementChild.classList.add('active','zindex');

				lastElementChild02.classList.add('active');

				lastElementChild.onanimationend = () => {//アニメーション完了後に実行する内容を記述
					firstElementChild.classList.remove('init');

					lastElementChild.classList.add('init');
					lastElementChild.classList.remove('zindex');

					firstElementChild02.classList.remove('init');
					lastElementChild02.classList.add('init');

				}
			}else if(lastElementChild.classList.contains("init")){

				firstElementChild.classList.add('active','zindex');


				firstElementChild02.classList.add('active');

				firstElementChild.onanimationend = () => {//アニメーション完了後に実行する内容を記述
					lastElementChild.classList.remove('init');

					firstElementChild.classList.add('init');
					firstElementChild.classList.remove('zindex');

					lastElementChild02.classList.remove('init');
					firstElementChild02.classList.add('init');


				}


			}

		},1000);


	}
}

// let HomeAnime = {
// 	init : function(){
// 		let parentElements = document.querySelectorAll( ".img01" );//img01要素を全て取得
// 		parentElements.forEach( parentElement =>{
// 			this.SectionAnime(parentElement);
// 		 });
// 	},
// 	SectionAnime : function(parentElement){
// 		const TimeDuration = 5000;
// 		const TimeDuration02 = 2000;
// 		const TimeDuration03 = 1000;
// 		setInterval(() => {
// 			//img01
// 			let firstElementChild = parentElement.firstElementChild;
// 			let lastElementChild = parentElement.lastElementChild;
// 			lastElementChild.classList.add('active');

// 			//img02
// 			let parentElement02 = parentElement.nextElementSibling;
// 			let firstElementChild02 = parentElement02.firstElementChild;
// 			let lastElementChild02 = parentElement02.lastElementChild;
// 			lastElementChild02.classList.add('active');

// 			new Promise((resolve) => {//2番目に実行する処理
// 				setTimeout(() => {
// 					// console.log("2番目");
// 					firstElementChild.classList.remove('init');
// 					lastElementChild02.classList.add('init');
// 					//順番入れ替え
// 					lastElementChild.parentNode.insertBefore(firstElementChild, lastElementChild.nextElementSibling);
// 					lastElementChild02.parentNode.insertBefore(firstElementChild02, lastElementChild02.nextElementSibling);

// 					resolve();//無事処理が終わったことを伝える
// 				}, TimeDuration02);
// 			}).then(() => {
// 				// console.log("3番目");
// 				// 処理が無事終わったことを受けとって実行される処理
// 					setTimeout(() => {
// 						// console.log("4番目");
// 						firstElementChild02.classList.remove('init');
// 						//2番目の要素のactiveを追加
// 						parentElement.lastElementChild.classList.add('active');//大サイズ
// 						parentElement02.lastElementChild.classList.add('active');//小サイズ
// 						setTimeout(() => {
// 							//１番目の要素のactiveを削除
// 							parentElement.firstElementChild.classList.remove('active');//大サイズ
// 							parentElement02.firstElementChild.classList.remove('active');//小サイズ
// 							firstElementChild.classList.add('init');

// 						}, TimeDuration03);
// 					}, TimeDuration02);
// 			});
// 		},TimeDuration)


// 	}
// }